import React from "react";
import { TopToolbar, ExportButton, FilterButton } from "react-admin";
import Tooltip from "@mui/material/Tooltip";

import { useMaxResultsByPlan } from "../../helpers/subscriptionPlan";

const ListActions = (props) => {
  const { filters } = props;
  const maxResults = useMaxResultsByPlan();

  return (
    <TopToolbar>
      <FilterButton filters={filters} />
      <Tooltip title={`Max Export = ${maxResults} contacts`}>
        <span>
          <ExportButton maxResults={maxResults} />
        </span>
      </Tooltip>
    </TopToolbar>
  );
};

export default ListActions;
